export enum ExtraProductsEnum {
  baggage = 0,
  lounge = 1,
  airportAssistance = 2
}

export type ExtraProductsEnumType = keyof typeof ExtraProductsEnum;
